import { restService } from "./RestService";
import { dateUtils } from "../utils/DateUtils";

export class AbstractEntityService {
    // Find entity (GET request)
    async find(url) {
        const data = await restService.get(url);

        //convert dates from string to Date
        if (Array.isArray(data)) {
            data.forEach(item => dateUtils.parseTimestampsToDates(item));
        }
        else if (typeof (data) === 'object') {
            dateUtils.parseTimestampsToDates(data)
        }

        return data;
    }

    // Create entity (POST request)
    async create(url, data) {
        let payload;

        if (Array.isArray(data)) {
            payload = [...data]
            payload.forEach(item => dateUtils.parseDatesToTimestamps(item));

        }
        else {
            payload = { ...data };
            dateUtils.parseDatesToTimestamps(payload);
        }

        const responseData = await restService.post(url, payload);

        if (Array.isArray(responseData)) {
            responseData.forEach(item => dateUtils.parseTimestampsToDates(item));
        }
        else if (typeof (responseData) === 'object') {
            dateUtils.parseTimestampsToDates(responseData)
        }

        return responseData;
    }

    // Update entity (PUT request)
    async update(url, data) {
        let payload;

        if (Array.isArray(data)) {
            payload = [...data]
            payload.forEach(item => dateUtils.parseDatesToTimestamps(item));

        }
        else {
            payload = { ...data };
            dateUtils.parseDatesToTimestamps(payload);
        }

        const responseData = await restService.put(url, payload);

        if (Array.isArray(responseData)) {
            responseData.forEach(item => dateUtils.parseTimestampsToDates(item));
        }
        else if (typeof (responseData) === 'object') {
            dateUtils.parseTimestampsToDates(responseData)
        }

        return responseData;
    }

    // Delete entity (DELETE request)
    async delete(url) {
        await restService.delete(url);
        return true;
    }

    handleError(error, message) {
        throw new Error(message, { cause: error });
    }
}

export const abstractEntityService = new AbstractEntityService();